@if (operatorStateSrv.context(); as context) {
	<header class="topbar">
		<div class="brand">
			<a class="brand-mark" routerLink="/" aria-label="Αρχική operator">
				<img src="/assets/logo_white.png" alt="" />
			</a>
			<div class="brand-copy">
				<a class="brand-home" routerLink="/">Operator</a>
				@if (context.stores.length > 1) {
					<button
						class="store-trigger"
						type="button"
						[attr.aria-expanded]="storeMenuOpen()"
						aria-controls="operator-store-menu"
						[attr.aria-label]="
							'Αλλαγή ενεργού καταστήματος. Τρέχον: ' + context.storeName
						"
						(click)="toggleStoreMenu()"
					>
						{{ context.storeName }}
						<span
							class="icon icon--chevron-down store-chevron"
							[class.is-open]="storeMenuOpen()"
						></span>
					</button>
					@if (storeMenuOpen()) {
						<div class="store-menu" id="operator-store-menu">
							@for (store of context.stores; track store.id) {
								<button
									type="button"
									[class.is-active]="store.id === context.storeId"
									(click)="switchStore(store.id)"
								>
									<span>{{ store.name }}</span>
									@if (store.id === context.storeId) {
										<span class="icon icon--check" aria-hidden="true"></span>
									}
								</button>
							}
						</div>
					}
				} @else {
					<span class="store-name">{{ context.storeName }}</span>
				}
			</div>
		</div>
		<div class="user-menu-wrap">
			<button
				class="operator-trigger"
				type="button"
				aria-controls="operator-user-menu"
				[attr.aria-expanded]="userMenuOpen()"
				[attr.aria-label]="'Λογαριασμός ' + context.userName"
				(click)="toggleUserMenu()"
			>
				<span class="icon icon--user-round" aria-hidden="true"></span>
				<strong>{{ context.userName }}</strong>
			</button>
			@if (userMenuOpen()) {
				<div class="user-menu" id="operator-user-menu">
					<button type="button" [disabled]="loggingOut()" (click)="logout()">
						Αποσύνδεση
					</button>
				</div>
			}
		</div>
	</header>
}
